import './App.css';
import Navibar from './components/Navibar';
import Home from './components/Home';
import Projects from './components/Projects';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Navibar />
      <Home />
      <Projects />
      <Contact />
    </div>
  );
}

export default App;
